module.exports = __webpack_public_path__ + "static/media/post1.0b25a4c1.jpg";